import { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebaseConfig";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";

function Reports() {
  const [members, setMembers] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const snapshot = await getDocs(collection(db, "members"));
      const rawData = snapshot.docs.map(doc => doc.data());

      const sorted = rawData
        .filter(m => m.member_id && m.member_id.startsWith("SAAM-2025-"))
        .sort((a, b) => {
          const numA = parseInt(a.member_id.split("-")[2]);
          const numB = parseInt(b.member_id.split("-")[2]);
          return numA - numB;
        });

      const final = sorted.map((m, i) => ({
        sr: i + 1,
        member_id: m.member_id,
        name: m.name || "",
        father_name: m.father_name || "",
        address: m.address || "",
      }));

      setMembers(final);
    };

    fetchData();
  }, []);

  // ✅ Export PDF — clean black & white only
  const exportPDF = () => {
    const doc = new jsPDF("landscape");

    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("SHINE AGRI ALLIED & MARKETING MULTISTATE COOPERATIVE SOCIETY LTD.", 14, 20);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(12);
    doc.text("VOTER LIST REPORT", 14, 28);

    autoTable(doc, {
      startY: 35,
      head: [["Sr. No.", "Membership No.", "Name", "Father/Husband Name", "Address"]],
      body: members.map(m => [m.sr, m.member_id, m.name, m.father_name, m.address]),
      theme: "grid",
      styles: {
        fontSize: 10,
        textColor: "#000000",
        lineColor: "#000000",
        lineWidth: 0.2,
        halign: "left",
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: "#000000",
        fontStyle: "bold",
        lineColor: "#000000",
        lineWidth: 0.4,
      },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
    });

    doc.save("VoterList_Report.pdf");
  };

  // ✅ Export Excel
  const exportExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(members);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "VoterList");
    XLSX.writeFile(workbook, "VoterList_Report.xlsx");
  };

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold text-gray-800 mb-4">
        Voter List Report
      </h2>

      <div className="mb-4 flex gap-3">
        <button
          onClick={exportPDF}
          className="bg-gray-800 hover:bg-black text-white px-4 py-2 rounded shadow"
        >
          Export PDF
        </button>
        <button
          onClick={exportExcel}
          className="bg-green-700 hover:bg-green-800 text-white px-4 py-2 rounded shadow"
        >
          Export Excel
        </button>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full border rounded shadow text-sm text-center">
          <thead className="bg-gray-200 text-gray-800">
            <tr>
              <th className="p-2 border">Sr. No.</th>
              <th className="p-2 border">Membership No.</th>
              <th className="p-2 border">Name</th>
              <th className="p-2 border">Father/Husband Name</th>
              <th className="p-2 border">Address</th>
            </tr>
          </thead>
          <tbody>
            {members.length > 0 ? (
              members.map((m, index) => (
                <tr key={index} className="hover:bg-gray-100">
                  <td className="p-2 border">{m.sr}</td>
                  <td className="p-2 border">{m.member_id}</td>
                  <td className="p-2 border">{m.name}</td>
                  <td className="p-2 border">{m.father_name}</td>
                  <td className="p-2 border text-left">{m.address}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="p-4 text-gray-500">
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Reports;
